/*
 By Osvaldas Valutis, www.osvaldas.info
 Available for use under the MIT License
 */

;(function ($, window, document, undefined) {
    'use strict';

    var cssTransitionSupport = function () {
            var s = document.body || document.documentElement, s = s.style;
            if (s.WebkitTransition == '') return '-webkit-';
            if (s.MozTransition == '') return '-moz-';
            if (s.OTransition == '') return '-o-';
            if (s.transition == '') return '';
            return false;
        },

        isCssTransitionSupport = cssTransitionSupport() === false ? false : true,

        cssTransitionTranslateX = function (element, positionX, speed) {
            var options = {}, prefix = cssTransitionSupport();
            options[prefix + 'transform'] = 'translateX(-50%)';
            options[prefix + 'transition'] = prefix + 'transform ' + speed + 's linear';
            element.css(options);
        },

        hasTouch = ( 'ontouchstart' in window ),
        hasPointers = window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
        wasTouched = function (event) {
            if (hasTouch)
                return true;

            if (!hasPointers || typeof event === 'undefined' || typeof event.pointerType === 'undefined')
                return false;

            if (typeof event.MSPOINTER_TYPE_MOUSE !== 'undefined') {
                if (event.MSPOINTER_TYPE_MOUSE != event.pointerType)
                    return true;
            }
            else if (event.pointerType != 'mouse')
                return true;

            return false;
        };

    $.fn.imageLightbox = function (options) {
        var options = $.extend(
            {
                selector: 'id="imagelightbox"',
                allowedTypes: 'png|jpg|jpeg|gif',
                animationSpeed: 250,
                preloadNext: true,
                enableKeyboard: true,
                quitOnEnd: false,
                quitOnImgClick: false,
                quitOnDocClick: true,
                onStart: false,
                onEnd: false,
                onLoadStart: false,
                onLoadEnd: false
            },
            options),

            targets = $([]),
            target = $(),
            image = $(),
            imageWidth = 0,
            imageHeight = 0,
            swipeDiff = 0,
            inProgress = false,

            isTargetValid = function (element) {
                return $(element).prop('tagName').toLowerCase() == 'a' && ( new RegExp('\.(' + options.allowedTypes + ')$', 'i') ).test($(element).attr('href'));
            },

            setImage = function () {
                if (!image.length) return true;

                var screenWidth = $(window).width() * 0.8,
                    screenHeight = $(window).height() * 0.9,
                    tmpImage = new Image();

                tmpImage.src = image.attr('src');
            },

            loadImage = function (direction) {
                if (inProgress) return false;

                direction = typeof direction === 'undefined' ? false : direction == 'left' ? 1 : -1;

                if (image.length) {
                    if (direction !== false && ( targets.length < 2 || ( options.quitOnEnd === true && ( ( direction === -1 && targets.index(target) == 0 ) || ( direction === 1 && targets.index(target) == targets.length - 1 ) ) ) )) {
                        quitLightbox();
                        return false;
                    }
                    var params = {'opacity': 0.01};
                    image.animate(params, options.animationSpeed, function () {
                        removeImage();
                    });
                    swipeDiff = 0;
                }

                inProgress = true;
                if (options.onLoadStart !== false) options.onLoadStart();

                setTimeout(function () {
                    image = $('<img ' + options.selector + ' />')
                        .attr('src', target.attr('href'))
                        .load(function () {
                            image.appendTo('.zoom-wrapper');
                            setImage();

                            var params = {};

                            image.css('opacity', 0.01);

                            inProgress = false;
                            if (options.onLoadEnd !== false) options.onLoadEnd();

                            if (options.preloadNext) {
                                var nextTarget = targets.eq(targets.index(target) + 1);
                                if (!nextTarget.length) nextTarget = targets.eq(0);
                                $('<img />').attr('src', nextTarget.attr('href')).load();
                            }
                        })
                        .error(function () {
                            if (options.onLoadEnd !== false) options.onLoadEnd();
                        })

                    var swipeStart = 0,
                        swipeEnd = 0,
                        imagePosLeft = 0;

                }, options.animationSpeed + 100);
            },

            removeImage = function () {
                if (!image.length) return false;
                image.remove();
                image = $();
            },

            quitLightbox = function () {
                if (!image.length) return false;
                image.animate({'opacity': 0}, options.animationSpeed, function () {
                    removeImage();
                    inProgress = false;
                    if (options.onEnd !== false) options.onEnd();
                });
            };

        $(window).on('resize', setImage);

        if (options.quitOnDocClick) {
            $(document).on(hasTouch ? 'touchend' : 'click', function (e) {
                if (image.length && !$(e.target).is(image)) quitLightbox();
            })
        }

        if (options.enableKeyboard) {
            $(document).on('keyup', function (e) {
                if (!image.length) return true;
                e.preventDefault();
                if (e.keyCode == 27) quitLightbox();
                if (e.keyCode == 37 || e.keyCode == 39) {
                    target = targets.eq(targets.index(target) - ( e.keyCode == 37 ? 1 : -1 ));
                    if (!target.length) target = targets.eq(e.keyCode == 37 ? targets.length : 0);
                    loadImage(e.keyCode == 37 ? 'left' : 'right');
                }
            });
        }

        $(document).on('click', this.selector, function (e) {
            if (!isTargetValid(this)) return true;
            e.preventDefault();
            if (inProgress) return false;
            inProgress = false;
            if (options.onStart !== false) options.onStart();
            target = $(this);
            loadImage();
        });

        this.each(function () {
            if (!isTargetValid(this)) return true;
            targets = targets.add($(this));
        });

        this.switchImageLightbox = function (index) {
            var tmpTarget = targets.eq(index);
            if (tmpTarget.length) {
                var currentIndex = targets.index(target);
                target = tmpTarget;
                loadImage(index < currentIndex ? 'left' : 'right');
            }
            return this;
        };

        this.quitImageLightbox = function () {
            quitLightbox();
            return this;
        };

        return this;
    };
})(jQuery, window, document);
//Lightbox für Zoom

var instances = new Array();
var selectors = new Array();
(function ($) {

    $(document).ready(function () {
        var overlayOn = function () {
                $('<div id="imagelightbox-overlay"></div>').appendTo('body');
            },
            overlayOff = function () {
                $('#imagelightbox-overlay').remove();
            },
            closeButtonOn = function (instance) {
                $('<a href="#" class="lightboxbtn" id="imagelightbox-close"><i class="fa fa-times"></i></a>').appendTo('body').on('click', function () {
                    $(this).remove();
                    instance.quitImageLightbox();
                    return false;
                });
            },
            closeButtonOff = function () {
                $('#imagelightbox-close').remove();
            };
        // ARROWS

        arrowsOn = function (instance, selector) {
            var $arrows = $('<button type="button" class="lightboxbtn imagelightbox-arrow imagelightbox-arrow-left"><i class="fa fa-chevron-left"></i></button><button type="button" class="lightboxbtn imagelightbox-arrow imagelightbox-arrow-right"><i class="fa fa-chevron-right"></i></button>');

            $arrows.appendTo('body');

            $arrows.on('click touchend', function (e) {
                e.preventDefault();

                var $this = $(this),
                    $target = $(selector + '[href="' + $('#imagelightbox').attr('src') + '"]'),
                    index = $target.index(selector);

                if ($this.hasClass('imagelightbox-arrow-left')) {
                    index = index - 1;
                    if (!$(selector).eq(index).length)
                        index = $(selector).length;
                }
                else {
                    index = index + 1;
                    if (!$(selector).eq(index).length)
                        index = 0;
                }

                instance.switchImageLightbox(index);
                return false;
            });
        },
            arrowsOff = function () {
                $('.imagelightbox-arrow').remove();
            },
            zoomButtonInit = function (instance, selector) {
                var $buttons = $('<button type="button" id="zoomInButton" class="lightboxbtn imagelightbox-zoom imagelightbox-zoomin"><i class="fa fa-plus"></i></button><button id="zoomOutButton" type="button" class="lightboxbtn imagelightbox-zoom imagelightbox-zoomout"><i class="fa fa-minus"></i></button>');
                $buttons.appendTo('body');
            },
            zoomButtonOn = function () {
                $('body').find('#imagelightbox').animate({'opacity': '1'}, 'slow');
                $('#imagelightbox').smartZoom({'containerClass': 'zoomableContainer'});

                $('#zoomInButton').click(zoomin);
                $('#zoomOutButton').click(zoomout);
                function zoomin(e) {
                    var scaleToAdd = 0.8;
                    $('#imagelightbox').smartZoom('zoom', scaleToAdd);
                }

                function zoomout(e) {
                    var scaleToAdd = 0.8;
                    scaleToAdd = -scaleToAdd;
                    $('#imagelightbox').smartZoom('zoom', scaleToAdd);
                }
            },
            zoomButtonOff = function () {
                $('body').removeClass('ovh');
                $('.zoom-wrapper').css('display', 'none');
                $('.imagelightbox-zoom').remove()
            }
        navigationOn = function (instance, selector) {
            var images = $(selector);
            if (images.length) {
                var nav = $('<div id="imagelightbox-nav"></div>');
                for (var i = 0; i < images.length; i++)
                    nav.append('<button type="button"></button>');

                nav.appendTo('body');
                nav.on('click touchend', function () {
                    return false;
                });

                var navItems = nav.find('button');
                navItems.on('click touchend', function () {
                    var $this = $(this);
                    if (images.eq($this.index()).attr('href') != $('#imagelightbox').attr('src'))
                        instance.switchImageLightbox($this.index());

                    navItems.removeClass('active');
                    navItems.eq($this.index()).addClass('active');

                    return false;
                })
                    .on('touchend', function () {
                        return false;
                    });
            }
        },
            navigationUpdate = function (selector) {
                var items = $('#imagelightbox-nav button');
                items.removeClass('active');
                items.eq($(selector).filter('[href="' + $('#imagelightbox').attr('src') + '"]').index(selector)).addClass('active');
            },
            navigationOff = function () {
                $('#imagelightbox-nav').remove();
            };

        $('.lightbox_gallery').each(function (index, value) {
            selectors[index] = 'a[data-imagelightbox="' + $(this).attr('data-selector') + '"]';
            instances[index] = $(selectors[index]).imageLightbox({
                animationSpeed: 250,                    // integer;
                preloadNext: true,                   // bool;            silently preload the next image
                enableKeyboard: true,                   // bool;            enable keyboard shortcuts (arrows Left/Right and Esc)
                quitOnEnd: false,                  // bool;            quit after viewing the last image
                quitOnImgClick: false,                  // bool;            quit when the viewed image is clicked
                quitOnDocClick: false,                   // bool;            quit when anything but the viewed image is clicked
                onStart: function () {
                    navigationOn(instances[index], selectors[index]);
                    overlayOn();
                    closeButtonOn(instances[index]);
                    zoomButtonInit();
                    arrowsOn(instances[index], selectors[index]);
                },
                onEnd: function () {
                    navigationOff();
                    overlayOff();
                    closeButtonOff();
                    zoomButtonOff();
                    arrowsOff();
                },
                onLoadStart: function () {

                },              // function/bool;   calls function when the image load begins
                onLoadEnd: function () {
                    $('body').addClass('ovh');
                    $('.zoomableContainer').remove();
                    $('.zoom-wrapper').css('display', 'block');
                    zoomButtonOn();
                    navigationUpdate(selectors[index]);
                    $('.imagelightbox-arrow').css('display', 'block');
                }// function/bool;   calls function when the image finishes loading
            });
        })
    });
}(jQuery));
